<form>
    @if (observationTypeGroups && observationTypeGroups.length > 0) {
        @for (typeGroup of observationTypeGroups; track typeGroup.group.id) {
            <app-row-with-toggle
                    [primaryText]="typeGroup.group.name"
                    [(checked)]="typeGroup.included"
                    (checkedChange)="updateObservations()"
            >
            </app-row-with-toggle>

            <mat-chip-set aria-label="Fish selection" class="ml-25">
                @for (type of typeGroup.group.observationTypes; track type.title) {
                    <mat-chip>{{ type.title }}</mat-chip>
                }
            </mat-chip-set>

        }
    } @else {
        No observation groups defined yet.
    }
</form>
